import { render, staticRenderFns } from "./grantCards.vue?vue&type=template&id=4f66a43c&scoped=true&"
import script from "./grantCards.vue?vue&type=script&lang=js&"
export * from "./grantCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f66a43c",
  null
  
)

export default component.exports